import { useEffect, useState } from "react";
import AsnList from "../List/AsnList";
import { Column } from "../../../Components/Tables/Table";
import { CustomASN } from "../model/asnOverview.model";
import { formatDate, formatNumber, prepareSearchColumns } from "../../../Utility/Utility";
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { TabConfig } from "../../../model/common/tabs";
import OffCanvas from "../../../Components/FormTag/OffCanvas";
import { useGlobalFilter } from "../../../hooks/useGlobalFilter";
import { SubmitHandler, useForm } from "react-hook-form";
import { asnAdvanceFilter } from "../Check-In/CheckIn.type";
import FormSelect from "../../../Components/FormTag/FormSelect";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import { lookUpService } from "../../../Services/common/lookup.service";
import { SelcetOption } from "../../../model/common/apiResponse";
import useEventSystem from "../../../events/useEventSystem";
import useWarehouseStore from "../../../store/warehouse/useWarehouseStore";
import useClientStore from "../../../store/client/useClientStore";

export default function AsnOverview() {
  const navigation = useNavigate();
  const { resetSearch } = useSearchStore();
  const [loading, setLoading] = useState(true);
  const [warehouseId, setWarehouseId] = useState<any>(null);
  const [clientId, setClientId] = useState<any>(null);
  const pageName = "ASN";
  const addUrl = "/inbound/asn/overview/add";
  const listUrl = "/inbound/asn/overview";
  const [advancedFilterData, setAdvancedFilterData] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [supplierData, setSupplierData] = useState<any>();
  const buttonStatus = true;

  const advanceFilterMapper: any = {
    "supplier": "supplier.code"
  };

  const { emit, event } = useEventSystem();
  const {
    isShowCanvas,
    toggleFilter,
    handleFilterCount,
    activeFilterCount,
  } = useGlobalFilter();

  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
  } = useForm<asnAdvanceFilter>({
    defaultValues: new asnAdvanceFilter(),
  });

  const db_columns = [
    {
      "data": "inbound_shipment.id"
    },
    {
      "data": "inbound_shipment.shipment_number"
    },
    {
      "data": "supplier.name as supplier_name"
    },
    {
      "data": "inbound_shipment.expected_arrival_date"
    },
    {
      "data": "inbound_shipment.door"
    },
    {
      "data": "no_of_lines"
    },
    {
      "data": "total_qty_expected"
    },
    {
      "data": "total_qty_received"
    },
    {
      "data": "inbound_shipment.status"
    }
  ];

  const { getSelectedWarehouse } = useWarehouseStore();
  const { getSelectedClient } = useClientStore();

  useEffect(() => {
    const subscriptionWarehouse = getSelectedWarehouse().subscribe((warehouse) => {
      setWarehouseId(warehouse?.id);
    });
    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionWarehouse.unsubscribe();
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedWarehouse, getSelectedClient]);

  const handleEditAction = (id: any) => {
    return navigation(`/inbound/asn/overview/edit/${id}`);
  };
  const dropdownOptions = (status: string) => [
    {
      option: "View",
      functionality: (id: number) => handelDetailAction(id)
    },
  ...((status?.toLocaleLowerCase()==='new') ? [
      {
        option: "Edit",
        functionality: (id: number) => handleEditAction(id)
      }
    ] : [])
  ];

  const exclude_columns = ["no_of_lines","total_qty_expected","total_qty_received"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);
  const columns: Column[] = [
    {
      name: "ASN #",
      column_name:"inbound_shipment.id",
      enableSorting:true,
      selector: (row:CustomASN) => (
          <span className="cursor-pointer text-primary" onClick={()=>handleRowClick(row?.id)}>
          {row?.id ?? "-"}
        </span>
      ),
    },
    {
      name: "Supplier ",
      column_name:"supplier.name",
      selector: (row:CustomASN) =>(
        <>
          {row?.supplier_name ?? "-"}
        </>
      )
    },
    {
      name: "ETA",
      column_name:"inbound_shipment.expected_arrival_date",
      selector: (row:CustomASN) =>(
        <>
        {(row?.expected_arrival_date)?formatDate(row?.expected_arrival_date):'-'}
        </>
      ),
    },
    {
      name: "Door",
      column_name:"inbound_shipment.door",
      selector: (row:CustomASN) => (
        <>
          {row?.door ?? "-"}
        </>
      ),
    },
    {
      name: "Lines",
      column_name:"no_of_lines",
      selector: (row:CustomASN) => (
        <>
        {row?.no_of_lines ?? "-" }
        </>
      ),
    },
    {
      name: "Expected Qty",
      column_name:"total_qty_expected",
      selector: (row:CustomASN) => (
        <>
          {formatNumber(row?.total_qty_expected) ?? 0}
        </>
      ),
    },
    {
      name: "Received Qty",
      column_name:"total_qty_received",
      selector: (row:CustomASN) => (
        <>
          {formatNumber(row.total_qty_received) ?? 0}
        </>
      ),
    },
 
    {
      name: (<><ArrowLeftRight/> <PlusCircle /></>),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical/>
          </span>
          <ul className="dropdown-menu action-items px-0 py-1">
            {dropdownOptions(row.status).map((option, index) => (
              <li
                key={index}
                className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
                onClick={() => option.functionality(row?.id)}
              >
                {option.option}
              </li>
            ))}
          </ul>
        </>
      ),
    },
  ];
  const pageTabs: TabConfig[] = [
    {
      order: 0,
      name: 'new',
      tabLable: 'New',
      visibility: true,
      status: true,
      multiSelect: null
    },
    {
      order: 1,
      name: 'in progress',
      tabLable: 'In Progress',
      visibility: true,
      status: false,
      multiSelect: null
    },
    {
      order: 2,
      name: 'complete',
      tabLable: 'Completed',
      visibility: true,
      status: true,
      multiSelect: null
    },
  ];

  const handleRowClick = (id: any) => {
    return navigation(`/inbound/asn/overview/details/${id}`);
  };
  const handelDetailAction = (id: any) => {
    return navigation(`/inbound/asn/overview/details/${id}`);
  };
  useEffect(() => {
    lookUpService.supplierLookup().then((response) => {
      const supData: SelcetOption[] =
        response?.data?.data?.results.map((obj: any) => ({
          label: obj.name,
          value: obj.code,
        }));
      setSupplierData(supData);
    })
  }, [])

  useEffect(() => {
     resetSearch();
    setLoading(false);
    emit('show_client_warning', false);
}, [])
  
  const canvasHeader = (
    <>
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Saved Filter
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              One line count
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              Special count
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
  const handleGlobalFilter = () => {
    toggleFilter();
  };
  const nextData: SubmitHandler<asnAdvanceFilter> = (data) => {
    setRefreshTrigger(refreshTrigger + 1);
    handleFilterCount(data);
    setAdvancedFilterData(data);
    toggleFilter();
  };
  
  const handelResetFilter = () => {
    reset(new asnAdvanceFilter());
    handleFilterCount(0);
    toggleFilter();
    setAdvancedFilterData(null);
  }
  const Offcanvas = (
    <OffCanvas
      show={isShowCanvas}
      handleClose={handleGlobalFilter}
      title="Advance Filter"
      headerChildren={canvasHeader}
    >
      <>
        <div className="offcanvas-body offcanvas-height custom-scrollbar">
          <form>
            <div className="">
              <div className="my-3">
                <label>Supplier</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="supplier"
                    control={control}
                    optionList={supplierData ?? []}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3">
          <button
            className="btn offcanvas-close-btn px-4 mx-2 "
            onClick={() => handelResetFilter()}
          >
            Clear
          </button>
          <button
            className="btn offcanvas-apply-btn px-4 px-2 "
            onClick={handleSubmit(nextData)}
          >
            Apply
          </button>
        </div>
      </>
    </OffCanvas>
  );


  return !loading ? (
    <AsnList
      db_columns={db_columns}
      search_columns={search_columns}
      columns={columns}
      pageName={pageName}
      addUrl={addUrl}
      listUrl={listUrl}
      pageTabs={pageTabs}
      Offcanvas={Offcanvas}
      handleGlobalFilter={handleGlobalFilter}
      buttonStatus={buttonStatus}
      checkboxStatus={false}
      tableMultiSelect={null}
      key={refreshTrigger}
      advancedFilterData={advancedFilterData}
      filterDataCount = {activeFilterCount}
      advanceFilterMapper = {advanceFilterMapper}
      warehouseId={warehouseId}
      clientId={clientId}
    />
  ):<Loader/>
}
